import React from 'react';
import { Link } from 'react-router-dom';
import { FaArrowRight } from 'react-icons/fa';
import HighlightText from '../components/core/HomePage/HighlightText';
import CTAButton from '../components/core/HomePage/Button';
import Banner from '../assets/Images/banner.mp4';
import CodeBlocks from '../components/core/HomePage/CodeBlocks';
import LearningLanguageSection from '../components/core/HomePage/LearningLanguageSection';
import TimeLineSection from '../components/core/HomePage/TimeLineSection';
import ReviewSlider from '../components/common/ReviewSlider';
import InstructorSection from '../components/core/HomePage/InstructorSection';
import Footer from '../components/common/Footer';
import ExploreMore from '../components/core/HomePage/ExploreMore';
import { useSelector } from 'react-redux';
import { ACCOUNT_TYPE } from '../utils/constants';

const Home = () => {
    const { user } = useSelector(state => state.profile);
    return (
        <div>
            <section className='relative max-w-maxContent mx-auto flex flex-col w-11/12 items-center text-white justify-between gap-8 pb-[15rem] mt-14'>
                <Link
                    to={`${user?.accountType === ACCOUNT_TYPE.INSTRUCTOR ?
                        '/dashboard/new-course' :
                        user?.accountType === ACCOUNT_TYPE.STUDENT ?
                            '/dashboard/enrolled-courses' :
                            '/signup'}`
                    }>
                    <div className='group mx-auto rounded-full mt-10 py-[0.1rem] bg-richblack-800 font-bold text-richblack-200 transition-all duration-200 hover:scale-95 drop-shadow-[0_1.5px_rgba(255,255,255,0.25)] hover:drop-shadow-none'>
                        <div className='group-hover:bg-richblack-900 md:text-md lg:text-lg flex flex-row items-center gap-2 rounded-full px-[2rem] py-[0.6rem] transition-all duration-200 hover:scale-95'>
                            <p>
                                {`${user?.accountType === ACCOUNT_TYPE.INSTRUCTOR ?
                                    'Add a Course' : user?.accountType === ACCOUNT_TYPE.STUDENT ?
                                        'Start Learning' :
                                        'Become an Instructor'}`
                                }</p>
                            <FaArrowRight />
                        </div>
                    </div>
                </Link>
                <div className='text-center text-3xl md:text-4xl font-semibold mt-7'>
                    Empower your Future with <HighlightText text={'Coding Skills'} />
                </div>
                <div className='w-[100%] md:w-[90%] text-center md:text-xl font-bold text-richblue-300 mt-2 md:mt-4'>
                    With our online coding courses, you can learn at your own pace, from anywhere in the world, and get access to a wealth of resources, including hands-on projects, quizzes, and personalized feedback from instructors.
                </div>
                <div className='flex flex-row gap-7 mt-8'>
                    <CTAButton active={true} linkTo={'/signup'}>
                        Learn More
                    </CTAButton>
                    <CTAButton linkTo={'/signup'}>
                        Book a Demo
                    </CTAButton>
                </div>
                <div className='mx-3 my-10 md:my-14 shadow-[10px_-5px_50px_-5px] shadow-blue-200'>
                    <video muted loop autoPlay className='md:shadow-[20px_20px_rgba(255,255,255)] shadow-[10px_10px_rgba(255,255,255)]'>
                        <source src={Banner} type='video/mp4' />
                    </video>
                </div>
                <div>
                    <CodeBlocks
                        position={'lg:flex-row'}
                        heading={
                            <div>Unlock Your <HighlightText text={"Coding Potential"} />  with our online courses</div>
                        }
                        subHeading={'Our courses are designed and taught by industry experts who have years of experience in coding and are passionate about sharing their knowledge with you.'}
                        ctaButton1={
                            {
                                btnText: 'Try it yourself',
                                linkTo: '/signup',
                                active: true,
                            }
                        }
                        ctaButton2={
                            {
                                btnText: 'Learn more',
                                linkTo: '/login',
                                active: false,
                            }
                        }
                        codeBlock={
                            `<!DOCTYPE html>
                            <html>
                            <head><title>StudyNexaa</title><linkrel="stylesheet"href="styles.css">
                            </head>
                            <body>
                            <h1><a href="/">Start Learning</a>
                            </h1>
                            <nav>
                            <ahref="/python">Python</a><ahref="/java">Java</a><ahref="/cpp">C++</a>
                            </nav>`
                        }
                        codeColor={'text-yellow-25'}
                        backgroundGradiant={'code-block1'}
                    />
                </div>
                <div>
                    <CodeBlocks
                        position={'lg:flex-row-reverse'}
                        heading={
                            <div>Start <HighlightText text={"coding in seconds"} /></div>
                        }
                        subHeading={"Go ahead, give it a try. Our hands-on learning environment means you'll be writing real code from your very first lesson."}
                        ctaButton1={
                            {
                                btnText: 'Continue lesson',
                                linkTo: '/login',
                                active: true,
                            }
                        }
                        ctaButton2={
                            {
                                btnText: 'Learn more',
                                linkTo: '/login',
                                active: false,
                            }
                        }
                        codeBlock={
                            `<!DOCTYPE html>
                            <html>
                            <head><title>StudyNexaa</title><linkrel="stylesheet"href="styles.css">
                            </head>
                            <body>
                            <h1><a href="/">Start Learning</a>
                            </h1>
                            <nav>
                            <ahref="/python">Python</a><ahref="/java">Java</a><ahref="/cpp">C++</a>
                            </nav>`
                        }
                        codeColor={'text-white-25'}
                        backgroundGradiant={'code-block2'}
                    />
                </div>
                <ExploreMore />
            </section>
            <section className='bg-pure-greys-5 text-richblack-700 relative'>
                <div className='homepage_bg h-[300px]'>
                    <div className='w-11/12 max-w-maxContent flex justify-between flex-col items-center gap-5 mx-auto'>
                        <div className='flex flex-row gap-7 text-white lg:mt-[200px] mt-8'>
                            <CTAButton active={true} linkTo={'/signup'}>
                                <div className='flex items-center justify-center gap-3'>
                                    <div>Explore Full Category</div>
                                    <FaArrowRight />
                                </div>
                            </CTAButton>
                            <CTAButton linkTo={'/login'}>
                                Learn More
                            </CTAButton>
                        </div>
                    </div>
                </div>
                <div className='mx-auto w-11/12 max-w-maxContent flex flex-col items-center justify-between gap-7 relative lg:top-0 -top-40'>
                    <div className='flex lg:flex-row flex-col items-center justify-between gap-5 my-16'>
                        <div className='md:text-4xl text-3xl font-semibold lg:w-[45%] w-full'>
                            Get the Skills you need for a <HighlightText text={'Job that is in demand'} />
                        </div>
                        <div className='flex flex-col lg:text-xl gap-10 lg:w-[40%] w-full'>
                            <p>The modern StudyNexaa is the dictates its own terms. Today, to be a competitive specialist requires more than professional skills.</p>
                            <CTAButton active={true} linkTo={'login'}>Learn More</CTAButton>
                        </div>
                    </div>
                </div>
                <TimeLineSection />
                <LearningLanguageSection />
            </section>
            <section className='w-11/12 mx-auto max-w-maxContent flex items-center flex-col justify-between gap-8 bg-richblack-900 text-white'>
                <InstructorSection />
                <h2 className='text-center md:text-4xl text-3xl md:font-semibold font-bold mt-10'>Review from Lerners</h2>
                <ReviewSlider />
            </section>
            <Footer />
        </div>
    )
}

export default Home;